const AppPageName = Object.freeze({
    ACCOUNTS: 'accounts',
    DOJO_REPORT: 'dojo-reports',
    ORDERS: 'orders',
    REPORT: 'report',
    SELL: 'sell',
    TODAY: 'today',
});

module.exports = AppPageName;
